var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.994 511.994",
    height: 512,
    viewBox: "0 0 511.994 511.994",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2576_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1084_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1296_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_187_",
    d: "m122.306 501.414c-8.174 0-16.291-2.56-23.231-7.6-12.287-8.922-18.328-23.762-15.765-38.729l21.985-128.387-93.299-90.896c-10.876-10.596-14.72-26.15-10.032-40.593 4.688-14.442 16.936-24.773 31.961-26.96l128.897-18.765 57.615-116.821c6.717-13.618 20.322-22.081 35.507-22.084h.011c15.181 0 28.785 8.454 35.507 22.065l9.87 19.987c2.445 4.952.414 10.949-4.539 13.394-4.95 2.445-10.948.414-13.394-4.539l-9.87-19.986c-3.377-6.838-9.948-10.921-17.575-10.921-.002 0-.003 0-.006 0-7.629.002-14.2 4.088-17.575 10.931l-59.94 121.536c-1.456 2.952-4.271 4.998-7.528 5.472l-134.1 19.522c-7.55 1.099-13.464 6.088-15.819 13.345-2.356 7.257-.5 14.768 4.965 20.092l97.064 94.564c2.357 2.297 3.434 5.606 2.878 8.851l-22.872 133.569c-1.288 7.52 1.629 14.687 7.803 19.169 6.174 4.483 13.891 5.039 20.643 1.486l119.93-63.092c2.913-1.533 6.393-1.533 9.307-.002l119.963 63.028c6.754 3.549 14.471 2.989 20.643-1.498 6.171-4.486 9.084-11.654 7.793-19.174l-22.943-133.556c-.558-3.244.517-6.554 2.874-8.853l97.014-94.615c5.462-5.327 7.314-12.839 4.954-20.095-2.36-7.255-8.276-12.241-15.827-13.336l-134.11-19.451c-3.257-.473-6.073-2.518-7.531-5.469l-10.272-20.801c-2.445-4.952-.414-10.949 4.539-13.394 4.952-2.446 10.948-.413 13.394 4.539l7.944 16.087 128.907 18.696c15.027 2.18 27.279 12.503 31.976 26.943 4.696 14.44.861 29.997-10.01 40.599l-93.25 90.945 22.053 128.375c2.571 14.965-3.462 29.808-15.744 38.737-12.281 8.93-28.262 10.088-41.705 3.025l-115.31-60.583-115.277 60.644c-5.845 3.079-12.177 4.599-18.473 4.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1993_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1996_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    d: "m312.247 107.439c-2.63 0-5.21-1.06-7.07-2.93-1.86-1.86-2.93-4.43-2.93-7.07 0-2.63 1.07-5.2 2.93-7.07 1.86-1.86 4.44-2.93 7.07-2.93 2.64 0 5.21 1.07 7.07 2.93s2.93 4.44 2.93 7.07c0 2.64-1.07 5.21-2.93 7.07-1.86 1.87-4.44 2.93-7.07 2.93z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star-2.213a35241b8445cd10870229e57960bd.svg";
export { ForwardRef as ReactComponent };